import { Title1, Body1 } from '@fluentui/react-components';
import React from 'react'
import { useTranslation } from 'react-i18next';

const PageHeader : React.FC<any> = ({styles}) => {
  const { t } = useTranslation();
  
  return (
    <div className={styles.header}>
        <Title1>{t('info.title', 'API Setup Guide')}</Title1>
        <br />
        <Body1>
            {t('info.subtitle', 'Learn how to obtain and configure API keys for different AI services.')}
        </Body1>
    </div>
  )
}

export default PageHeader;